/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/lodash/noop.js
// module id = ./node_modules/recharts/node_modules/lodash/noop.js
// module chunks = 1